/** @jsxImportSource theme-ui */

import React from 'react'
import { Button, ButtonProps } from 'theme-ui'
import { CopyIcon } from './icons/copy'

export const CopyButton: React.FC<{ text: string } & ButtonProps> = ({
  children,
  text,
  ...props
}) => {
  return (
    <Button
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 3,
        flexShrink: 0,
      }}
      onClick={() => navigator.clipboard.writeText(text)}
    >
      <CopyIcon sx={{ mr: 2 }} />
      {children ?? 'Copy'}
    </Button>
  )
}
